import { BREAKPOINT_KEYS } from "./muiBreakpoints";
export var sortBreakpoints = breakpoints => breakpoints.sort((a, b) => BREAKPOINT_KEYS.indexOf(a) - BREAKPOINT_KEYS.indexOf(b));
export var combineBreakpoints = function combineBreakpoints() {
  var result = [];

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  args.forEach(item => {
    var breakpoints = Array.isArray(item) ? item : Object.keys(item);
    breakpoints.forEach(k => {
      if (!result.includes(k)) {
        result.push(k);
      }
    });
  });
  return sortBreakpoints(result);
};